import { render, staticRenderFns } from "./ConvoyDialog.vue?vue&type=template&id=528b9e06&scoped=true&"
import script from "./ConvoyDialog.vue?vue&type=script&lang=js&"
export * from "./ConvoyDialog.vue?vue&type=script&lang=js&"
import style0 from "./ConvoyDialog.vue?vue&type=style&index=0&id=528b9e06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528b9e06",
  null
  
)

export default component.exports